import { BtnRed } from '@/components/Buttons';
import { ObserverContainer } from '@/components/ObserverContainer';
import { splitLines } from '@/modules/utils';
import { useEffect, useRef } from 'react';

export const Shape = () => {
  const ref = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (ref.current) {
      splitLines(ref.current);
    }
  }, []);
  return (
    <div className="prometheus-shape">
      <div className="container">
        <div className="main">
          <div className="left">
            <ObserverContainer className="flex column">
              <h2 className="integralfc-h2 reveal-from-bottom" ref={ref}>
                SHAPE THE XBORG ECOSYSTEM
              </h2>
              <p>
                Vote on key product, business or ecosystem decisions as a
                Promethean, to guide the future of XBorg.
              </p>

              <div className="flex">
                <BtnRed href="" label="Visit Snapshot" />
              </div>
            </ObserverContainer>
          </div>
          <div className="right">
            <div className="card">
              <div className="card-left">
                <h5>XIP #12 - XBG Presale Terms</h5>
                <p>21/02/2024 · Proposal</p>
              </div>
              <div className="badge green">CLOSED</div>
            </div>
            <div className="card">
              <div className="card-left">
                <h5>XIP #11 - XBG Presale Go/No-Go</h5>
                <p>31/01/2024 · Proposal</p>
              </div>
              <div className="badge green">CLOSED</div>
            </div>
            <div className="card">
              <div className="card-left">
                <h5>XIP #10 - Prometheus Chestplate NFT</h5>
                <p>25/01/2024 · Proposal</p>
              </div>
              <div className="badge green">CLOSED</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
